import { broadcastConnectEvent } from '@atlassian/jira-connect-utils';
import type { ChangeEvent } from '@atlassian/jira-issue-ecosystem';
import { isFilterIssueChangedEvents } from '@atlassian/jira-issue-ecosystem/src/feature-flags';

export const EVENT_NAME = 'ISSUE_CHANGED';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const targetSpecNoDialogs = (registration: any) =>
	registration?.extension?.options?.moduleType !== 'dialogs';

export const emitIssueChangedEvent = (eventDetails: ChangeEvent) => {
	broadcastConnectEvent(
		EVENT_NAME,
		isFilterIssueChangedEvents() ? targetSpecNoDialogs || {} : {},
		eventDetails,
	);
};
